import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import Layout from './layout'
import { CardsSection, SimpleBanner, AreasSection } from '../components'
import useCourses from '../hooks/useCourses'
import useTrainingTypes from '../hooks/useTrainingTypes'
import PropTypes from 'prop-types'
import ReusableFilterSelect from './ReusableFilterSelect.js'
import '../css/ReusableFilter.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSliders, faXmark } from '@fortawesome/free-solid-svg-icons'
import useAcUnitsCode from '../hooks/useAcUnitsCode.js'

const Area = ({ data, location }) => {
  const [q, setQ] = useState('')

  const area = data.allStrapiInterestArea.nodes[0]

  const dataCourses = useCourses()
  const fjsCourses = dataCourses?.allStrapiFjsCourses?.nodes

  const areaCourses = fjsCourses.filter((course) =>
    course.interest_areas.find((areaInt) => area.slug === areaInt.slug)
  )

  const newCourses = areaCourses.filter(
    (course) => course.dateStart >= new Date().toISOString()
  )
  const expiredCourses = areaCourses
    .filter((course) => course.dateStart < new Date().toISOString())
    .reverse()

  const dataTrainingTypes = useTrainingTypes()
  const trainingTypes = dataTrainingTypes.allStrapiTrainingType.nodes
  const dataAcUnitsCodes = useAcUnitsCode()
  const acUnitsCodes = dataAcUnitsCodes.allStrapiAcUnitsCodes.nodes

  //Filtrar cursos por slug, Categorias y Unidad Academica
  function filterCourses(courses) {
    return courses.filter((course) => {
      const matchesSlug = q === '' || course.training_type.slug === q

      const matchesCategory = !selectedItems.category || selectedItems.category.length === 0
        ? true
        : selectedItems.category.includes(course.training_type.id)

      const matchesLevel = !selectedItems.level || selectedItems.level.length === 0
        ? true
        : selectedItems.level.includes(course.academic_unit.code)

      return matchesSlug && matchesCategory && matchesLevel
    })
  }

  function capitalize(title) {
    const lower = title.toLowerCase()
    return title.charAt(0).toUpperCase() + lower.slice(1)
  }
  const [selectedItems, setSelectedItems] = useState({})
  const [resetFilters, setResetFilters] = useState(false)

  // Categories and Academic Units Filters
  const filterOptions = {
    category: trainingTypes.map(item => ({
      key: item.strapiId,
      label: item.title
    })).sort((a, b) => a.label.localeCompare(b.label)),
    level: acUnitsCodes.map(item => ({
      key: item.code,
      label: item.name === "Universidad" ? "Otros" : item.name
    })).sort((a, b) => a.label.localeCompare(b.label)),
  }

  const filteredExpiredCourses = filterCourses(expiredCourses)
  
  // Reset all filters
  const handleResetFilters = () => {
    setSelectedItems({
      category: [],
      level: []
    })
    setQ('')
    setResetFilters(true)
  }
  
 // Show mobile content 
 const [content, setContent] = useState(true)

  useEffect(() => {
    const isMobile = window.innerWidth <= 768 
    setContent(!isMobile) 
  }, [])

 const toggleButton = () => {
   setContent((prevContent) => !prevContent)
 }

 const trainingTypesFilter =
    location.pathname !== '/administracion-negocio'
      ? trainingTypes
          .filter((trainingType) => trainingType.slug !== 'formacion-ejecutiva')
          .map((trainingType, idx) => (
            <button
              key={`type-${idx}`}
              className={'btn-outline-darker'}
              onClick={() => {
                setQ(trainingType.slug)
              }}
            >
              {capitalize(trainingType.title)}
            </button>
          ))
      : trainingTypes.map((trainingType, idx) => (
          <button
            key={`type-${idx}`}
            className={'btn-outline-darker'}
            onClick={() => {
              setQ(trainingType.slug)
            }}
          >
            {capitalize(trainingType.title)}
          </button>
        ))

  // TODO: Old filters - Delete in the next Feature
  // const trainingTypesFilter =
  //   location.pathname !== '/administracion-negocio'
  //     ? trainingTypes
  //         .filter((trainingType) => trainingType.slug !== 'formacion-ejecutiva')
  //         .map((trainingType, idx) => (
  //           <button
  //             key={`type-${idx}`}
  //             className={'btn-outline-darker'}
  //             onClick={() => {
  //               setQ(trainingType.slug)
  //             }}
  //           >
  //             {capitalize(trainingType.title)}
  //           </button>
  //         ))
  //     : trainingTypes.map((trainingType, idx) => (
  //         <button
  //           key={`type-${idx}`}
  //           className={'btn-outline-darker'}
  //           onClick={() => {
  //             setQ(trainingType.slug)
  //           }}
  //         >
  //           {capitalize(trainingType.title)}
  //         </button>
  //       ))

  return (
    <Layout>
      <AreasSection />
      <SimpleBanner
        image={area?.banner}
        text={area?.title}
        icon={area?.icon[0]}
      />
      {areaCourses.length > 0 && (
        <div className="primary-background">
          <div className="container pt-5 ">
            <div className="order-container-mobile">
              <button onClick={toggleButton} className="btn-filter">
                <FontAwesomeIcon icon={faSliders} size="sm" className="me-2" />
                Filtros
              </button>
              {Object.values(selectedItems).some(
                (arr) => arr && arr.length > 0
              ) && (
                <button
                  className="buttonResetMobile"
                  onClick={handleResetFilters}
                >
                  <FontAwesomeIcon icon={faXmark} size="sm" className="me-2" />
                  Limpiar
                </button>
              )}
            </div>
            <div className="row px-3 area-chip">
              {/*    {trainingTypesFilter} */}
              <div
                className={`filter-container ${content ? 'visible' : 'hidden'}`}
              >
                <div className="filters-wrapper">
                  <ReusableFilterSelect
                    label="Categoría del curso"
                    options={filterOptions.category}
                    selectedValues={selectedItems.category || []}
                    onChange={(values) =>
                      setSelectedItems({ ...selectedItems, category: values })
                    }
                    resetTrigger={resetFilters}
                    onResetComplete={() => setResetFilters(false)}
                    simpleValues={false}
                    valueKey="key"
                    labelKey="label"
                  />

                  <ReusableFilterSelect
                    label="Unidad Académica"
                    options={filterOptions.level}
                    selectedValues={selectedItems.level || []}
                    onChange={(values) =>
                      setSelectedItems({ ...selectedItems, level: values })
                    }
                    resetTrigger={resetFilters}
                    onResetComplete={() => setResetFilters(false)}
                    simpleValues={false}
                    valueKey="key"
                    labelKey="label"
                  />
                </div>
                {Object.values(selectedItems).some(
                  (arr) => arr && arr.length > 0
                ) && (
                  <button
                    className="buttonResetDesktop"
                    onClick={handleResetFilters}
                  >
                    <FontAwesomeIcon
                      icon={faXmark}
                      size="sm"
                      className="me-2"
                    />
                    Limpiar
                  </button>
                )}
              </div>
              {/* <button
                className={'btn-outline-darker'}
                onClick={() => {
                  setQ('')
                }}
              >
                Ver todos
              </button> */}
            </div>
          </div>
          <CardsSection
            courses={filterCourses(newCourses)}
            areas={true}
            id={'courses'}
          />
          {expiredCourses.length > 0 && (
            <CardsSection
              courses={filterCourses(expiredCourses)}
              related={true}
              title={
                filteredExpiredCourses.length > 0
                  ? 'Cursos comenzados'
                  : 'No hay cursos comenzados en esta categoría.'
              }
              id={'cursos-comenzados'}
            />
          )}
        </div>
      )}
    </Layout>
  )
}

export const query = graphql`
  query ($slug: String!) {
    allStrapiInterestArea(filter: { slug: { eq: $slug } }) {
      nodes {
        slug
        title
        id
        icon {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        banner {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`

Area.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object
}

export default Area
